const PRODUCT_PROPERTY = 'product';
const CHILD_CONTAINER_DATA_PROPERTY = 'childContainerData';
const CTA_CLASS = 'ancillaries_open_child';

module.exports = Backbone.Model.extend({
    PRODUCT_PROPERTY: 'product',
    CHILD_CONTAINER_DATA_PROPERTY: 'childContainerData',
    CTA_CLASS: 'ancillaries_open_child',

    defaults: {
        product: undefined,
        childContainerData: undefined,
    },

    getProduct() {
        return this.get(PRODUCT_PROPERTY);
    },

    getChildContainerData() {
        return this.get(CHILD_CONTAINER_DATA_PROPERTY);
    },

    getProductProperty() {
        return PRODUCT_PROPERTY;
    },

    getChildContainerDataProperty() {
        return CHILD_CONTAINER_DATA_PROPERTY;
    },

    getCtaClass() {
        return CTA_CLASS;
    },
});
